// extracted by mini-css-extract-plugin
export var componentFull = "ModularityGroupWrapper-module--componentFull--uUZ9v";
export var componentGroup = "ModularityGroupWrapper-module--componentGroup--exrql";